document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('[data-wirkstoffe-grid]');
  if (!grid) return;

  var searchInput = document.querySelector('[data-wirkstoffe-search]');
  var categoryGroup = document.querySelector('[data-wirkstoffe-category-group]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-wirkstoffe-card]'));
  var emptyState = grid.querySelector('[data-wirkstoffe-empty]');
  var activeCategory = 'all';

  function applyFilters() {
    var query = (searchInput && searchInput.value || '').trim().toLowerCase();
    var visibleCount = 0;

    cards.forEach(function (card) {
      var matchesSearch = query === '' || card.dataset.name.indexOf(query) !== -1;
      var matchesCategory = activeCategory === 'all' || card.dataset.category === activeCategory;
      var visible = matchesSearch && matchesCategory;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount !== 0;
  }

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  if (categoryGroup) {
    categoryGroup.addEventListener('click', function (event) {
      var button = event.target.closest('[data-category]');
      if (!button) return;

      activeCategory = button.dataset.category;
      categoryGroup.querySelectorAll('[data-category]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn === button);
      });
      applyFilters();
    });
  }
});
